import { Location } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { ManagerService } from '@app/_core/services/manager.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { environment } from '@environments/environment';
import { catchError, EMPTY, map } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AgentStatus } from '@app/_core/helper/AgentStatus';
import { Utils } from '@app/_core/helper/Utils';
import { ConfirmDialogComponent } from 'src/app/pages/common/confirm-dialog/confirm-dialog.component';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { LoaderService } from '@app/_core/services/loader.service';
import { WindowsWrapper } from '../../../../app.config';
import { Inject } from '@angular/core';
import { ManagerLiveMoniterComponent } from '@app/pages/console/livestatuses/manager-live-moniter/manager-live-moniter.component'
@Component({
  selector: 'app-historicalmetric-details',
  templateUrl: './historicalmetric-details.component.html',
  styleUrls: ['./historicalmetric-details.component.scss'],
  encapsulation:ViewEncapsulation.Emulated
})
export class HistoricalmetricDetailsComponent implements OnInit {
  // === Live status header state (ported from LiveStatusDetails) ===
modalRef?: BsModalRef;

selectedAgentId: any;           
skillDetails: any;
queueDetails: any;
agentDetail: any;
currStatusLabel: string = 'LoggedOut';
agentStatusDuration: string = '';
agentStatusColor: string = '';
liveStatusControls: boolean = false;
ManageAssignments = false;
managerViewBtn = false;
managerHideBtn = false;
managerListenBtn = false;
managerDisconnectBtn = false;
managerRemoteLogoffBtn = false;
managerMuteOnBtn = false;
managerMuteOffBtn = false;
ManageAgents = false;
AuditAgents = false;
Admin = false;
canStatusBeLoggedOff: boolean = false
CurrentAgent: any;
currStatus: any;
isMuted = false;
isPhoneQueue = false;
isAgentUsingWrapper = false;
isManagerUsingWrapper = false;
isLiveViewing = false;
isListeningIn = false;
isCallActive = false;
isConnecting = false;
interactionHeader: string = "LAST INTERACTION";
queueHeader: string = "CURRENT QUEUE";
canLiveView = false;     
isCustomLabel: boolean = false;
CurrentStatus: boolean = false;
liveStatusWaitShort = 5000;
liveStatusWaitLong = 10000;
liveStatusTimer: any;
 clientAbbr: any;
  historicalMetricDetail: any;
  modifiedQueueData: any;
  modifiedSkillData: any;
  debugMode = false;
  title: string = '';
  selectedInteractionId: any;
  isDesktopOnly: boolean = false;
  allowPopUps: boolean = true;
  isEnabled:boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private managerService: ManagerService,
    private securityService: SecurityService,
    private location: Location,
    private webStorageService: WebStorageService,
    
    private agentStatus: AgentStatus,
    private utils: Utils,
    private confirmDialogComponent: ConfirmDialogComponent,
    private mainController: MainControllerComponent,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private loaderService: LoaderService,
@Inject(WindowsWrapper) private OnvidaWrapper: any

    
  )
   {
    this.route.params.subscribe((params: any) => {
      this.reset();
     // console.log(params);
      this.selectedInteractionId = params.id;
      this.selectedAgentId = params.id;
      //  alert(params.id)
      this.GetHistoricalMetricByID(params.id);
      this.GetLiveStatusByID(params.id);
      this.getAgentCustomAccess(params.id);
      // this.GetAgentQueues(params.id);
      // this.GetAgentSkills(params.id);
      //this.loadSkillAgents(params.id)
    });
  }
        
        
     private formatAgentStatusDuration(totalSeconds: number): string 
     {
         let secs = Math.abs(Math.trunc(totalSeconds));
         const days = Math.floor(secs / 86400);
         secs -= days * 86400;
        const hours = Math.floor(secs / 3600);
        secs -= hours * 3600;
        const minutes = Math.floor(secs / 60);
        secs -= minutes * 60;
        const parts: string[] = [];
        if (days > 0) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
        if (hours > 0) parts.push(`${hours}hrs`);
        if (minutes > 0) parts.push(`${minutes}mins`);
        parts.push(`${secs}sec`);
        return `${parts.join(' ')} ago`;
}

  ngOnInit(): void {
    this.debugMode =
      environment.environment == 'DEV' || environment.environment == 'STAGE' || environment.environment == 'TEST';
    this.canLiveView = this.securityService.validateGrant('LiveView');
    this.fetchGrands();
  }
  GetHistoricalMetricByID(id: number) {
    this.managerService
      .GetHistoricalMetricByID(id)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetHistoricalMetricByID');
          if (isValid) {
            this.historicalMetricDetail = data.Response.Data;
            this.title = 'Agent ' + this.historicalMetricDetail.ID + ' - ' + this.historicalMetricDetail.Name;
            // Build header state from the historical payload's LiveStatus
           const ls = this.historicalMetricDetail?.LiveStatus;
           this.canStatusBeLoggedOff = !!ls ? !!ls.CanBeLoggedOff : false;
// Map to AgentStatus model (reusing helper like LiveStatus page)
          const hasStatus = !!ls;
          const statusId = hasStatus ? ls.StatusID : this.agentStatus.Statuses.LoggedOut;
          this.currStatus   = this.agentStatus.getStatusByID(statusId);
         this.currStatusLabel = this.currStatus?.label || 'LoggedOut';
         this.agentStatusColor = this.currStatus?.color || '';
    //     this.agentStatusDuration = hasStatus
    //    ? this.utils.formatDuration(ls.Duration, 's', false, false, false)
    //  : '';
    this.agentStatusDuration = hasStatus ? this.formatAgentStatusDuration(ls.Duration) : '';
       this.isPhoneQueue = hasStatus ? (ls?.QueueName?.indexOf('Chat') == -1) : false;
       this.isAgentUsingWrapper = (hasStatus && ls.AppClientType == "WindowsWrapper");
      this.isManagerUsingWrapper = false; // as in LiveStatus, this comes from wrapper; keep false here
// Recompute header controls after data load
         this.updateLiveStatusControls();
            this.queueDetails = {
              ID: this.historicalMetricDetail.ID,
              owner: 'agent',
              object: 'queue',
              service: this.managerService,
              method: 'GetAgentQueues',
              priorities: false,
              persistence: false,
              roles: false,
              disable: undefined,
            };

            this.skillDetails = {
              ID: this.historicalMetricDetail.ID,
              owner: 'agent',
              object: 'skill',
              service: this.managerService,
              method: 'GetAgentSkills',
              priorities: true,
              persistence: true,
              roles: false,
              disable: undefined,
            };

            //"skill", "agent", this.service(), "GetSkillAgents", true, true, !cls.QBRSecurity().validateGrant("ManageAssignments")
            //detail:skillDetail, agentlist:agentList,
            //this.setInnerWidthHeightParameters();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  getAgentCustomAccess(id: number) {
        this.managerService.AgentCustomAccess(id)
            .subscribe(res => {
                this.allowPopUps = res?.AllowPopup;
                this.isDesktopOnly = res?.WrapperOnly;
                this.isEnabled = true; // Enable checkboxes after fetching access rights
            });
    }
  saveChanges() {
    const skills = [];
    const queues = [];
    if (this.modifiedQueueData?.length > 0) {
      for (const queue of this.modifiedQueueData) {
        queues.push(queue.ID);
      }
    }
    if (this.modifiedSkillData?.length > 0) {
      for (const skill of this.modifiedSkillData) {
        const priority = skill.Priority == null ? '0' : skill.Priority;
        const status = skill.ID + '|' + priority + '|' + skill.Persistent;
        skills.push(status);
      }
    }
    const data = {
      capResults: true,
      id: this.historicalMetricDetail.ID,
      ext: this.historicalMetricDetail.Extension,
      queues: queues,
      skills: skills,
      company: this.webStorageService.getItemFromSessionStorage('company'),
      user: this.webStorageService.getItemFromSessionStorage('currentUser'),
      wrapperOnly: this.isDesktopOnly,
      allowPopUps: this.allowPopUps
    };
    this.managerService
      .editAgentQueuesAndSkills(data)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'EditAgentQueuesAndSkills');
          if (isValid) {
            this.location.back();
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }
  goBack() {
    this.location.back();
  }
   modifyWrapperGrant($event) {
      this.isDesktopOnly =  $event.checked;
    }
     modifyAllowPopUpsGrant($event) {
        this.allowPopUps =  $event.checked;
    } 
  onSelectQueue(data: any) {
    this.modifiedQueueData = data;
  }
  onSelectSkill(data: any) {
    this.modifiedSkillData = data;
  }

  fetchGrands() {
    this.canLiveView = this.securityService.validateGrant('LiveView');
    this.CurrentAgent = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.clientAbbr = this.webStorageService.getItemFromSessionStorage('company');
     this.ManageAgents = this.securityService.validateGrant('ManageAgents');
      this.AuditAgents  = this.securityService.validateGrant('AuditAgents');
      this.Admin   = this.securityService.validateGrant('Admin');
      this.clientAbbr   = this.webStorageService.getItemFromSessionStorage('company');
          }
  // === Live header: button handlers ===
  Startlivemoniter() {
    const initialState = {
      AgentName: this.title,
      AgentId: this.historicalMetricDetail?.ID,
      managerId: this.CurrentAgent?.UserID,
      clientName: this.clientAbbr?.toLowerCase(),
      managerAPI: this.managerService
    };
    const config: ModalOptions = { backdrop: 'static', keyboard: false, class: '', initialState };
    this.modalRef = this.modalService.show(ManagerLiveMoniterComponent, config);
  }
  
  listenInPrep() {
    this.loaderService.display(true);
    const timeToDelay = this.mainController.CheckLastCallCompletedTimeBeforeCall();
    (async () => {
      await this.delay(timeToDelay);
      this.isConnecting = true;
      this.isListeningIn = true;
      this.isMuted = true;
      this.managerService.JoinAgentsCall(this.historicalMetricDetail?.ID, 0)
        .pipe(
          map((data: any) => {
            this.listenInSuccess(data.Response.Data);
            this.loaderService.display(false);
          }),
          catchError(error => {
            this.listenInFailure(error, error);
            this.loaderService.display(false);
            return EMPTY;
          })
        ).subscribe();
    })();
  }
  
  listenInSuccess = (response: any) => {
    if (response != null) {
      this.isCallActive = true;
      this.isConnecting = false;
      this.mainController.eListentInHandler(this.isMuted, this.isListeningIn);
      this.updateLiveStatusControls();
    } else {
      this.listenInFailure(null, null);
    }
  }
  
  listenInFailure(errorCode: any, message: any) {
    this.listenInStop();
  }
  
  listenInStop() {
    this.mainController.endCall(false, false);
    this.mainController.setLastCallCompletedTime(new Date());
    this.isCallActive = false;
    this.isMuted = false;
    this.isListeningIn = false;
    this.updateLiveStatusControls();
  }
  
  eManagerMuteBtnClickHandler() {
    if (this.isMuted) this.muteStop();
    else this.muteStart();
  }
  
  muteStart = () => {
    this.mainController.muteUnmuteMic(true);
    this.isMuted = true;
    this.updateLiveStatusControls();
  }
  
  muteStop = () => {
    this.confirmDialogComponent
      .confirmdialog('Remote Log Off', 'Are you sure? Unmuting will change your review mode from Listen In to Barge.', 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.mainController.muteUnmuteMic(false);
          this.isMuted = false;
          this.updateLiveStatusControls();
        }
      })
      .catch(() => {});
  }
  
  RemoteLogOff() {
    this.confirmDialogComponent
      .confirmdialog('Remote Log Off', 'You are about to forcibly log out a user that is logged in to the application! Do you want to continue?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.listenInStop();
          this.managerService
            .remotelogoff(this.historicalMetricDetail?.ID)
            .pipe(map(() => {}), catchError(error => { return EMPTY; }))
            .subscribe();
        }
      })
      .catch(() => {});
  }
  updateLiveStatusControls() {
    let currStatus = this.currStatus;
    var isAuditor = !this.ManageAgents && this.AuditAgents;
    let canLogOff = this.ManageAgents;
    if (!canLogOff || !this.canStatusBeLoggedOff) {
        canLogOff = false;
    } 
    this.CurrentStatus = ((this.ManageAgents || this.AuditAgents)
    && this.selectedAgentId != this.CurrentAgent.UserID
    && currStatus != this.agentStatus.Statuses.LoggedOut
    && currStatus != this.agentStatus.Statuses.Disconnected); 
    
    if (!this.isCustomLabel)
        this.CurrentStatus =  this.CurrentStatus && currStatus !=this.agentStatus.Statuses.Default;
    
    this.liveStatusControls =this.CurrentStatus;
    let isManager = this.canLiveView && !this.isManagerUsingWrapper && this.isAgentUsingWrapper;

    this.managerViewBtn = (isManager && !this.isLiveViewing);
    this.managerHideBtn = (isManager && this.isLiveViewing);
    this.managerListenBtn = (!this.isListeningIn && this.isPhoneQueue);

    this.managerDisconnectBtn = this.isListeningIn;
    this.managerRemoteLogoffBtn = (canLogOff);

    this.managerMuteOnBtn = (!isAuditor && this.isListeningIn && !this.isMuted && !this.isConnecting);
    this.managerMuteOffBtn = (!isAuditor && this.isListeningIn && this.isMuted && !this.isConnecting);
}
  //Update the Live Status and enabled buttons
  getLiveStatus() {
    clearInterval(this.liveStatusTimer);
    this.managerService
        .GetLiveStatusByIDSilent(this.selectedAgentId)
        .pipe(
            map((data: any) => {
                this.updateLiveStatus(data.Response.Data);
            }),
            catchError(error => {
                console.log(error);
                return EMPTY;
            })
        )
        .subscribe();
}
updateLiveStatus(data: any) {
  let hasStatus = (data != null);
  this.canStatusBeLoggedOff = (data != null) ? data.CanBeLoggedOff : false;
  this.currStatus = this.agentStatus.getStatusByID(hasStatus ? data.StatusID : this.agentStatus.Statuses.LoggedOut);
  let currStatus = this.currStatus;
  let currStatusLabel = currStatus.label;
  this.interactionHeader = (((currStatus == this.agentStatus.Statuses.OnCall || currStatus == this.agentStatus.Statuses.PostCall) ? 'CURRENT' : 'LAST') + ' INTERACTION');
  this.queueHeader = (((currStatus == this.agentStatus.Statuses.Away || currStatus == this.agentStatus.Statuses.LoggedOut || currStatus == this.agentStatus.Statuses.Disconnected) ? 'LAST' : 'CURRENT') + ' QUEUE');
  if (hasStatus && (data.LastInteractionTypeID == 7 || data.LastInteractionTypeID == 8)) {
      if (currStatus.id == 5) {
          currStatusLabel = "On Chat";
      } else if (currStatus.id == 8) {
          currStatusLabel = "Post Chat";
      }
  }
  if (currStatus.id == 11 && data.QueueType.toString().indexOf('Chat') != -1) {
      currStatusLabel = "Waiting For Chat";
  }
  this.currStatusLabel = currStatusLabel;
  this.isCustomLabel = false;
  if (hasStatus && currStatus.id == -1 && data.StatusID >= 5001) {
      this.currStatusLabel = data.Status;
      this.isCustomLabel = true;
  }
  //this.agentStatusDuration = ((hasStatus) ? this.utils.formatDuration(data.Duration, 's', false, false, false) : '');
  this.agentStatusDuration = hasStatus ? this.formatAgentStatusDuration(data.Duration) : '';
  this.agentStatusColor = currStatus.color;
  this.isPhoneQueue = ((hasStatus) ? data?.QueueName?.indexOf('Chat') == -1 : false);
  this.isAgentUsingWrapper = (hasStatus && data.AppClientType == "WindowsWrapper");
  this.isManagerUsingWrapper = this.OnvidaWrapper.IsWrapper;
  if (currStatus == this.agentStatus.Statuses.OnCall && this.isListeningIn && !this.isCallActive && !this.isConnecting) {
      var self = this;
      console.log("Listen In Sync"); 
  } else if (currStatus != this.agentStatus.Statuses.OnCall && this.isListeningIn && this.isCallActive) {
      console.log("Listen In Sync not OnCall", currStatus);
      this.listenInStop();
  } else if ((currStatus == this.agentStatus.Statuses.LoggedOut) && this.isLiveViewing) {
      console.log("Listen In Sync LoggedOut");
      this.listenInStop();
  } else {
      this.updateLiveStatusControls();
  }
  this.liveStatusTimer = setTimeout(() => { this.getLiveStatus(); }
      , (this.isListeningIn || this.isLiveViewing) ? this.liveStatusWaitShort : this.liveStatusWaitLong);

}
GetLiveStatusByID(id: number) {
  this.managerService
      .GetLiveStatusByID(id)
      .pipe(
          map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetLiveStatusByID');
              if (isValid) {
                  this.updateLiveStatus(data.Response.Data['LiveStatus']);
                  this.agentDetail = data.Response.Data;
                  this.title = 'Agent ' + this.agentDetail.ID + ' - ' + this.agentDetail.Name;
                  this.queueDetails = {
                      ID: this.agentDetail.ID,
                      owner: 'agent',
                      object: 'queue',
                      service: this.managerService,
                      method: 'GetAgentQueues',
                      priorities: false,
                      persistence: false,
                      roles: false,
                      disable: undefined,
                  };

                  this.skillDetails = {
                      ID: this.agentDetail.ID,
                      owner: 'agent',
                      object: 'skill',
                      service: this.managerService,
                      method: 'GetAgentSkills',
                      priorities: true,
                      persistence: true,
                      roles: false,
                      disable: undefined,
                  };
              }
          }),
          catchError(error => {
              console.log(error);
              return EMPTY;
          })
      )
      .subscribe();
}
  
  // Simple delay helper
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  reset() {
    this.ManageAssignments = false;
    this.AuditAgents = false;
    this.ManageAgents = false;
    this.Admin = false;
    this.canStatusBeLoggedOff = null;
    this.isAgentUsingWrapper = false;
    this.isManagerUsingWrapper = false;
    this.isLiveViewing = false;
    this.isListeningIn = false;
    this.isCallActive = false;
    this.isConnecting = false;
    this.liveStatusWaitShort = 5000;
    this.liveStatusWaitLong = 10000;
    this.liveStatusTimer;
    this.currStatusLabel = '';
    this.agentStatusDuration = '';
    this.agentStatusColor = '';
    this.liveStatusControls = false;
    this.managerViewBtn = false;
    this.managerHideBtn = false;
    this.managerListenBtn = false;
    this.managerDisconnectBtn = false;
    this.managerRemoteLogoffBtn = false;
    this.managerMuteOnBtn = false;
    this.managerMuteOffBtn = false;
    this.CurrentAgent = null;
    this.currStatus = null;
    this.isMuted = false;
    this.isDesktopOnly = false;
    this.allowPopUps = false;
    this.mainController.setLastCallCompletedTime(null);
    clearInterval(this.liveStatusTimer);
}
  ngOnDestroy() {
    this.listenInStop();
        this.reset();
    clearInterval(this.liveStatusTimer);
  }
}
